import React, { Component } from 'react';
import './style.css';
import DB from '../../Config/db';
import Work from '../../Components/WorkCard/WorkCard';

export default class WorkSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      works: DB.works,
      eductions: DB.educations,
    };
  }

  render() {
    return (
      <section className='dark-bg' id='work'>
        <div className='container'>
          <div className='headerCont'>
            <h3>Work Experience</h3>
          </div>

          <div className='worksCont'>
            {this.state.works.map((w, i) => (
              <Work data={w} bunc='at' key={'Work1-' + i} />
            ))}
          </div>

          <div className='headerCont'>
            <h3>Educations</h3>
          </div>
          <div className='worksCont'>
            {this.state.eductions.map((w, i) => (
              <Work data={w} bunc='from' key={'edu' + i} />
            ))}
          </div>
        </div>
      </section>
    );
  }
}
